import { app } from '../../../../app';
import { userFromDto } from '../../administrators/administrators.dto';
app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reseller.new-company', {
        url: '/new-company',
        component: 'companyResellerNewCompany',
        params:{createdCompany:null},
        resolve: {
            administrators,
            createdCompany
        }
    })
}


/** @ngInject */
function createdCompany($stateParams) {
    return $stateParams.createdCompany;
}

/** @ngInject */
function administrators($filter, account, companyId, RoleResource) {
    return RoleResource.getAllCompanyUsersWithRole(companyId)
        .then(users => users.map(userFromDto))
        .then(users => users.map(user => ({
            ...user, order: user.order + (account.login === user.saaspassId ? 1 : 0)
        })))
        .then(users => $filter('orderBy')(users, 'order', true))
}


// WEBPACK FOOTER //
// ./src/portal/states/company/reseller/new-company/new-company.state.js